import React, {Component} from 'react'

class Intro extends Component {

  render () {

    const {
      title,
      subTitle,
      media
    } = this.props

    return (
      <div className="Intro">

          <div className="Intro-cover">
            <div className="Intro-media">{ media }</div>
          </div>

          <div className="Intro-head">
            <h1 className="Intro-title">{ title }</h1>
            <h3 className="Intro-subTitle">{ subTitle }</h3>
          </div>


      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/js/components/Intro/Intro.jsx